/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocsPermissionDetail {
    getFixupPrototypeFunction() { return AwsSsmDocsPermissionDetail.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocsPermissionDetail>): AwsSsmDocsPermissionDetail {
        let obj = Object.assign(new AwsSsmDocsPermissionDetail(), model);
        AwsSsmDocsPermissionDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocsPermissionDetail>): AwsSsmDocsPermissionDetail {
        if (!model) return null;
        return AwsSsmDocsPermissionDetail.newInstance(<AwsSsmDocsPermissionDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocsPermissionDetail) {
        if (!obj) return;

        models.AwsSsmDocsPermissionDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocsPermissionDetail): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocsPermissionDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.account_sharing_info) {
            for (let val of this.account_sharing_info) {
                models.AwsSsmDocsAccountSharingInfo.fixupPrototype(val);
            }
        }
    }

    /**
     * The account IDs that have permission to use this document.
     */
    account_ids: Array<string>;

    /**
     * A list of Amazon Web Services accounts where the current document is shared and the version shared with each account
     */
    account_sharing_info: Array<models.AwsSsmDocsAccountSharingInfo>;

}
